module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p'), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("Publisher: Amy Marson")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("Creative Director: Gailen Runge")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("Editor: Lynn Koolish")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("Technical Editors: Alison M. Schmidt and Gailen Runge")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("Cover/Book Designer: Page + Pixel")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("Production Coordinator: Zinnia Heinzmann")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("Production Editors: Jennifer Warren, Nicole Rolandelli, and Jeanie German")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("Illustrator: Lon Eric Craven")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("Photo Assistants: Carly Jean Marin and Mai Yong Vang")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("Style photography by Lucy Glover and instructional photography by Diane Pedersen and Amanda Jean Nyberg, unless otherwise noted")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("Published by Stash Books, an imprint of C&T Publishing, Inc., P.O. Box 1456, Lafayette, CA 94549")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33def79f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/02_copyright.vue
// module id = 60
// module chunks = 0